import { Fragment, type ReactNode } from 'react';

export enum RuleEffect {
  Show,
}

interface Props {
  effect: RuleEffect.Show;
  active: boolean;
  children: ReactNode;
}

export function Rule(props: Props) {
  const { effect, active } = props;

  switch (effect) {
    case RuleEffect.Show: {
      const { children } = props;
      if (active !== true) {
        return null;
      }

      return <Fragment key="rule">{children}</Fragment>;
    }
  }

  return null;
}
